import React, { RefObject, forwardRef, useState } from "react";
import { Button } from "../button";
import { TimePicker } from "../timePicker";
import { roundUpTime, setClass } from "../../utils";

interface PushButtonsProps {
  onConfirm: () => void;
  onCancel: () => void;
  offerTime: (offeredTime: Date) => Promise<any>;
  ref: React.MutableRefObject<HTMLDivElement>;
}

export const PushButtons = forwardRef<HTMLDivElement, PushButtonsProps>((
  { onCancel, onConfirm, offerTime }, ref: RefObject<HTMLDivElement>
) => {
  const [isTimeOfferShow, setTimeOfferShow] = useState(false);

  const [startDate, setStartDate] = useState(roundUpTime(new Date()));

  const switchTimeOfferShow = () => setTimeOfferShow((prev) => !prev);

  const onOfferTime = () => offerTime(startDate)
    .then(() => setTimeOfferShow(false));

  const stopPropagation = (e: React.MouseEvent<HTMLDivElement, MouseEvent>) => e.stopPropagation(); 

  return (
    <>
      <div 
        onClick={stopPropagation} 
        className={setClass('push-buttons fade-in', isTimeOfferShow && 'none')}
      >
        <Button 
          title='Отказаться'
          onClick={onCancel}
          className="outlined push-button"
        />
        <Button
          title='Предложить время'
          onClick={switchTimeOfferShow}
          className="outlined push-button"
        />
        <Button
          title='Принять приглашение'
          onClick={onConfirm}
          className="push-button"
        />
      </div>
      
      <div 
        onClick={stopPropagation} 
        className={setClass('push-buttons fade-in', !isTimeOfferShow && 'none')}
      >
        <TimePicker
          value={startDate}
          onChange={setStartDate} 
          readOnly={false}        
        />
        <Button 
          title="Отмена"
          className="outlined push-button"
          onClick={switchTimeOfferShow}/>
        <Button 
          title="Отправить"
          className="push-button"
          onClick={onOfferTime}
        />
      </div>
    </>
  )
})